export default __webpack_public_path__ + "static/media/logo-exosswallet.87a2e2ee.png";